import { cn } from "@/packages/utils/cn";

interface Props {
  size?: number;
  className?: string;
  showWordmark?: boolean;
}

export function EdLogo({ size = 16, className, showWordmark = true }: Props) {
  const s = size + 6;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 font-sans font-semibold tracking-tight text-foreground",
        className,
      )}
      style={{ fontSize: size }}
    >
      <svg
        width={s}
        height={s}
        viewBox="0 0 22 22"
        className="shrink-0"
        aria-hidden="true"
      >
        <rect
          x="0"
          y="0"
          width="22"
          height="22"
          rx="5"
          className="fill-ink"
        />
        <circle cx="11" cy="18.2" r="1.3" className="fill-signal-red" />
        <path
          d="M11 18.2 L6.2 7.5"
          className="stroke-paper"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <path
          d="M5.6 9.6 l-1.4 1.4 l1.4 1.4"
          className="stroke-paper"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M11 18.2 L11 5.5"
          className="stroke-paper"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <circle cx="11" cy="6" r="1.6" className="fill-signal-red" />
        <path
          d="M11 18.2 L15.8 7.5"
          className="stroke-paper"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <path
          d="M16.4 9.6 l1.4 1.4 l-1.4 1.4"
          className="stroke-paper"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {showWordmark && (
        <span>
          Swisstools
          <span className="font-medium text-faint">.dev</span>
        </span>
      )}
    </span>
  );
}
